import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { KybDocumentType } from '../../../../../__generated__/GQL';
import { DeleteDraftStatutesDocument } from '../graphql/mutations/deleteDraftStatutes.gql';
import { SendDraftStatutesDocument } from '../graphql/mutations/sendDraftStatutes.gql';
import { CapitalDepositDraftStatutesDocument } from '../graphql/queries/CapitalDepositDraftStatutes.gql';
import { Model } from './model';

export enum Service {
  DeleteDocument = 'deleteDocument',
  SendDocument = 'sendDocument',
}

const services: MachineServices<Model, Service> = {
  deleteDocument: async ({ getModuleData }, event) => {
    if (event.type !== 'DELETE_DOCUMENT') {
      throw new Error(`deleteDocument called on event ${event.type}`);
    }

    const { companyProfileId } = getModuleData().data.viewer.company;

    await apolloClient.mutate({
      awaitRefetchQueries: true,
      mutation: DeleteDraftStatutesDocument,
      refetchQueries: [
        {
          query: CapitalDepositDraftStatutesDocument,
          variables: {
            companyProfileId,
          },
        },
      ],
      variables: {
        input: {
          kybDocumentId: event.data.kybDocumentId,
        },
      },
    });
  },

  sendDocument: ({ getModuleData }, event) => {
    if (event.type !== 'SUBMIT_DOCUMENT_FILE') {
      throw new Error(`sendDocument called on event ${event.type}`);
    }

    const { companyProfileId } = getModuleData().data.viewer.company;
    const { firebaseBucket, firebaseRef } = event.data;

    return apolloClient.mutate({
      awaitRefetchQueries: true,
      mutation: SendDraftStatutesDocument,
      refetchQueries: [
        {
          query: CapitalDepositDraftStatutesDocument,
          variables: {
            companyProfileId,
          },
        },
      ],
      variables: {
        input: {
          companyProfileId,
          firebaseBucket,
          firebaseRef,
          type: KybDocumentType.DraftStatutes,
        },
      },
    });
  },
};

export default services;
